__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@aiml/platform";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("leaflet", "1.9.4", function() { return __webpack_require__.e(8511).then(function() { return function() { return __webpack_require__(42181); }; }); });
			register("react-dom", "17.0.2", function() { return function() { return __webpack_require__(86599); }; }, 1);
			register("react-leaflet", "4.2.1", function() { return Promise.all([__webpack_require__.e(8511), __webpack_require__.e(4450), __webpack_require__.e(894)]).then(function() { return function() { return __webpack_require__(35610); }; }); });
			register("react-redux", "7.2.1", function() { return function() { return __webpack_require__(6467); }; }, 1);
			register("react", "17.0.2", function() { return function() { return __webpack_require__(50390); }; }, 1);
			initExternal(72500);
			initExternal(5164);
			initExternal(57256);
			initExternal(5176);
			initExternal(92421);
			initExternal(43760);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};